module.exports = __webpack_public_path__ + "static/Cultivation-hero-100-06cf975b0479cda07a104f5cfc8ff9d4.jpg";